<template>
<div class="row" v-if="team">
    <messageModal v-if="showMessage" message="les achats sont enregistrés, votre TV est à jour" @closeMessage="goToDetail"></messageModal>
    <messageModal v-if="showErrorModal" message="mmmhhh Quelque chose s'est mal passé. Contactez l'admin. Désolé pour ça." @closeMessage="showErrorModal=false"></messageModal>
    <confirmModal v-if="showFinishRevokesConfirmModal"
                  message="Vous êtes sûr de finir vos renvois ?"
                  @confirm="confirmValidateRevokes()"
                  @closeMessage="showFinishRevokesConfirmModal = false"></confirmModal>
    <spinningModal v-if="showSpinner"></spinningModal>
        <div class="panel">
            <div class="panel-content">
                <div class="row columns">
                    <div class="panel-title">
                        Les temps sont durs ?
                    </div>
                    <div class="row">
                        <div class="large-9 large-centered note">
                        Tu sais coco, une équipe, c'est comme une mongolfière...
                        </div>
                    </div>
                    <br>
                    <ul class="tabs horizontal" data-tab>
                        <li @click="activatedTab = 1"><a :class="{activated : activatedTab === 1}">Joueurs</a></li>
                        <li @click="activatedTab = 2"><a :class="{activated : activatedTab === 2}">Encadrement</a></li>
                        <li v-if="team.rostered_star_player" @click="activatedTab = 3"><a :class="{activated : activatedTab === 3}">Star players</a></li>
                    </ul>
                    <br>
                    <div class="inner-tab">
                        <player-revoke ref="playerRevoker"
                                         :hidden="activatedTab != 1" :roster="roster"
                                         @updatePlayerToRevoke="updatePlayerListToRevoke()"
                                         :team="team"
                                         ></player-revoke>
                        <stuff-revoker ref="stuffRevoker"
                                        :hidden="activatedTab != 2"
                                        @updateRevokedStuff="updateStuffListTorRevoke()"
                                        :roster="roster"
                                        :team="team"
                                        ></stuff-revoker>
                    </div>
                </div>
              <div v-if="playerListToRevoke.length > 0 || stuffListToRevoke" class="row columns">
                <div class="large-6 large-offset-3 inner-title large-centered">
                  Le plan social
                </div>
                <div v-if="playerListToRevoke.length > 0" class="large-6 large-offset-3 inner-subtitle">
                  Les joueurs qui nous quittent
                  <table>
                    <thead>
                        <tr class="">
                            <th width="10%">num</th>
                            <th width="40%">Nom</th>
                            <th width="40%">Position</th>
                        </tr>
                    </thead>
                    <tbody class="roster">
                        <tr v-for="player in playerListToRevoke">
                            <td>{{player.id}}</td>
                            <td>{{getPlayerDatas(player.id).name}}</td>
                            <td>{{getPlayerDatas(player.id).ref_roster_line}}</td>
                        </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="stuffListToRevoke" class="large-6 large-offset-3 inner-subtitle">
                  L'encadrement qui part en pré-retraite
                  <table>
                    <thead>
                    <tr class="">
                      <th width="50%"></th>
                      <th width="50%">Qté</th>
                    </tr>
                    </thead>
                    <tbody class="roster">
                      <tr v-if="stuffListToRevoke.revokedApo">
                        <td>Apothicaire</td>
                        <td>1</td>
                      </tr>
                      <tr v-if="stuffListToRevoke.revokedRerolls">
                        <td>Rerolls</td>
                        <td>{{stuffListToRevoke.revokedRerolls}}</td>
                      </tr>
                      <tr v-if="stuffListToRevoke.revokedAssistants">
                        <td>Assistants</td>
                        <td>{{stuffListToRevoke.revokedAssistants}}</td>
                      </tr>
                      <tr v-if="stuffListToRevoke.revokedPompoms">
                        <td>Pom-poms</td>
                        <td>{{stuffListToRevoke.revokedPompoms}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
              <div class="row columns">
                <div class="large-6 large-centered columns">
                    <button @click="goToDetail" class="light-grey-button">Retour</button>
                    <button @click="validateRevokes" class="">Valider le plan social</button>
                </div>
              </div>
              <br>
              <div v-if="errorMsg" class="row">
                <div class="large-12 large-centered columns text-centered">
                  <div class="error text-centered">{{errorMsg}}</div>
                </div>
              </div>
            </div>
        </div>
</div>
<div v-else>
  <spinner></spinner>
</div>
</template>

<script>
import store from '../../store/index.js'
import { mapGetters } from 'vuex'
import spinner from '../common/spinner.vue'
import spinningModal from '../common/spinning-modal.vue'
import messageModal from '../common/message-modal.vue'
import confirmModal from '../common/confirm-modal'
import starPurchase from './purchases/star-purchase'
import stadiumPurchase from './purchases/stadium-purchase'
import spiralingExpenseModal from '../common/spiraling-expense-modal.vue'
import playerRevoke from './revokes/player-revokes'
import stuffRevoker from './revokes/stuff-revoke'
import teamPurchases from '../../api/team-purchases.api'

export default {
  name: 'teamRevokes',
  components: {
    spinner,
    stuffRevoker,
    messageModal,
    playerRevoke,
    confirmModal,
    spinningModal,
    spiralingExpenseModal,
    starPurchase,
    stadiumPurchase
  },
  props: {
    'id': Number
  },
  data () {
    return {
      activatedTab: 1,
      showFinishRevokesConfirmModal: false,
      showMessage: false,
      showSpinner: false,
      showSpiralingExpenseModal: false,
      showErrorModal: false,
      playerListToRevoke: [],
      stuffListToRevoke: null,
      errorMsg: ''
    }
  },
  computed:
  {
    ...mapGetters([
      'currentUser'
    ]),
    ...mapGetters({
      roster: 'detailedRoster',
      team: 'detailedTeam'
    })
  },
  methods: {
    updatePlayerListToRevoke: function () {
      this.playerListToRevoke = this.$refs.playerRevoker.getPlayerToRevokeList()
    },
    updateStuffListTorRevoke: function () {
      this.stuffListToRevoke = this.$refs.stuffRevoker.getStuffToRevokeList()
    },
    getPlayerDatas (id) {
      return this.team.players.find(pl => {
        return pl.id === id
      })
    },
    goToDetail () {
      store.dispatch('getDetailedTeam', this.id.toString())
      this.showMessage = false
      this.showSpiralingExpenseModal = false
      this.$router.push({name: 'TeamDetail', params: { id: this.id.toString() }})
    },
    validateRevokes () {
      // si pas d'achat, on sort
      if (this.playerListToRevoke.length <= 0 && !this.stuffListToRevoke) {
        this.goToDetail()
        return
      }
      this.showFinishRevokesConfirmModal = true
    },
    confirmValidateRevokes () {
      this.showFinishRevokesConfirmModal = false

      let revokes = {}
      revokes.revoke = {}
      // gestion du stuff
      if (this.$refs.stuffRevoker.revokedApo === 1) {
        revokes.revoke.apo = 1
      }
      if (this.$refs.stuffRevoker.revokedRerolls > 0) {
        revokes.revoke.reroll = this.$refs.stuffRevoker.revokedRerolls
      }
      if (this.$refs.stuffRevoker.revokedAssistants > 0) {
        revokes.revoke.assistants = this.$refs.stuffRevoker.revokedAssistants
      }
      if (this.$refs.stuffRevoker.revokedPompoms > 0) {
        revokes.revoke.cheerleaders = this.$refs.stuffRevoker.revokedPompoms
      }
      revokes.revoke.players = this.$refs.playerRevoker.getPlayerToRevokeList()
      this.publishPurchases(revokes)
    },
    publishPurchases (revokeList) {
      this.showSpinner = true
      teamPurchases.api.publishTeamPurchases(this.team.id, revokeList)
        .then(response => {
          this.goToDetail()
        },
        error => {
          console.log('erreur impossible to publish purchases')
          console.log(error)
        })
    }
  },
  created () {
    store.dispatch('hideLeaguePanel')
    store.dispatch('deactivateFullSizePage')
    store.dispatch('getDetailedTeam', this.id.toString())
    store.dispatch('getDetailedRoster', this.id.toString())
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.roster{
    font-weight: 300;
}

.roster tr:nth-of-type(odd) {
    transition: background-color 0.15s;
    background-color: #E9EDEF;
}

.roster tr:nth-of-type(even) {
    background-color: #ffffff;
}

/***** gestion des formats de cellules*/

thead tr th {
    background-color: #ffffff;
    text-align: center;
    font-weight: 200;
    font-size:0.8rem;
}

.roster tr td{
    padding: 0.5rem 0rem;
    text-align: center;
    font-size:0.7rem;
}

.roster tr td.sous-total{
    font-weight: 400;
    padding: 0.4rem 0rem;
}


.roster tr td.sous-total.right{

}

button.row{
    margin-left: 0.4rem;
}

.team-score {
    font-size: 2rem;
    font-weight: 450;
    padding-top: 1rem;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}

.match-result {
    font-size: 1.2rem;
    font-weight: 200;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}

.match-team-name {
    font-size: 1.7rem;
    font-weight: 300;
    padding-top: 1rem;
    padding-bottom: 0.2rem;
    padding-left: 0.2rem;
}
.roster tr td.action{
    padding: 0.4rem 0.3rem;
}

button.action {
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 0.8rem;
    font-weight: 600
}
.note {
    font-weight: 100;
    font-size: 0.8rem;
}
.error {
  color:#E7505A;
}

.inner-title{
  padding-top: 1rem;
  margin-bottom: 0.3rem;
  text-align: center;
  font-size: 1.3rem;
  font-weight: 400;
}

.inner-subtitle{
  text-align: left;
  font-size: 0.8rem;
  font-weight: 300;
  margin-bottom: 0.3rem
}

.tabs {
    border-style: none;
    padding-top: 1.2rem;
    border-bottom: 1px solid #cacaca;
    padding-bottom: 0.4rem
}

.tabs li{
    float: left;
    margin-left : 0rem;
    /* padding : 0.4rem 0.8rem ; */
    margin-right : 0rem;
    /* position: relative; */
    bottom: -1px;
    margin-bottom:0rem;
}

.tabs li a {
    color:#596374;
    font-weight: 400;
    transition: background-color 0.5s,border-top-color 0.5s;
    padding : 0.4rem 0.8rem ;
}

.tabs > li a:hover {
    border-top: 2px solid #2c3e50;
}

.tabs > li a.activated {
    border: 1px solid #cacaca;
    border-bottom: 3px solid white;
    border-top: 2px solid #2c3e50;
    position: relative;
}

.inner-tab {
  padding-left: 1rem;
  padding-right: 1rem;
}

.summary {
  font-weight: 700;
}
.note {
  font-size: 0.8rem;
}
.red {
  color: #D05454
}
</style>



// WEBPACK FOOTER //
// team-revoke.vue?128f9dcd